import React from 'react';
import './ui.css';

/** Switch used in the Active columns (blog, app video, banners). */
export default function Toggle({ checked, onChange, disabled = false, label, className = '' }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={label}
      disabled={disabled}
      className={`sv-toggle ${checked ? 'is-on' : ''} ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onChange(!checked);
      }}
    >
      <span className="sv-toggle__thumb" />
    </button>
  );
}
